// @flow

import React, { type Node } from "react"
import styled, { keyframes } from "styled-components"

const DashAnimation = keyframes`
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
`
const RotateAnimation = keyframes`
  100% {
    transform: rotate(360deg);
  }
`

const Wrapper = styled.svg`
  animation: ${RotateAnimation} 2s linear infinite;
  z-index: 2;
  width: ${p => p.size}px;
  height: ${p => p.size}px;
  position: relative;
`

const Circle = styled.circle`
   {
    stroke: ${props =>
      props.inverted ? props.theme.color2 : props.theme.color1};
    stroke-linecap: round;
    animation: ${DashAnimation} 1.5s ease-in-out infinite;

    ${p =>
      p.color &&
      `
      stroke: ${p.color};
    `}
  }
`
const Scale = styled.div``

type Props = {
  size?: number,
  inverted?: boolean,
  color?: string
}

const baseSize = 50
const LoadingIcon = ({ size = 50, inverted = false, color }: Props): Node => {
  const scale = size / baseSize

  return (
    <Scale style={{ transform: `scale(${scale})` }}>
      <Wrapper size={baseSize} viewBox={`0 0 ${baseSize} ${baseSize}`}>
        <Circle
          inverted={inverted}
          cx={baseSize / 2}
          cy={baseSize / 2}
          r={baseSize / 2 - 5}
          fill="none"
          strokeWidth={5}
          color={color}
        />
      </Wrapper>
    </Scale>
  )
}

export default LoadingIcon
